import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  success?: boolean;
  icon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, success, icon, className = '', ...props }, ref) => {
    const baseClasses = `
      w-full px-2 py-1.5 border rounded-2xl font-medium text-slate-900 
      placeholder:text-slate-400 transition-all duration-200 
      focus:outline-none focus:ring-2 focus:ring-offset-0
      ${icon ? 'pl-10' : 'pl-2'}
      ${error ? 'pr-10' : success ? 'pr-10' : 'pr-2'}
    `;

    const stateClasses = error
      ? 'border-red-300 bg-red-50/50 focus:border-red-500 focus:ring-red-500/20 focus:bg-white'
      : success
        ? 'border-green-300 bg-green-50/50 focus:border-green-500 focus:ring-green-500/20 focus:bg-white'
        : 'border-slate-300 bg-slate-50/50 focus:border-blue-500 focus:ring-blue-500/20 focus:bg-white hover:border-slate-400';

    return (
      <div className='relative'>
        {icon && (
          <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
            {icon}
          </div>
        )}
        <input
          ref={ref}
          className={`${baseClasses} ${stateClasses} ${className}`}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
